<table mdbTable #tableEl="mdbTable">
  <thead>
    <tr>
      <th
        class="table_heading1"
        scope="col"
        [mdbTableSort]="products"
        sortBy="name"
      >
        Pass Name
      </th>
      <th
        class="table_heading1 no_mobile"
        scope="col"
        [mdbTableSort]="products"
        sortBy="productType"
      >
        Pass Type
      </th>
      <th
        class="table_heading1 no_mobile"
        scope="col"
        [mdbTableSort]="products"
        sortBy="scheduleType"
      >
        Schedule Type
      </th>
      <th
        class="table_heading1 no_mobile"
        scope="col"
        [mdbTableSort]="products"
        sortBy="scheduleType"
      >
        Access
      </th>
      <th
        class="table_heading1"
        scope="col"
        [mdbTableSort]="products"
        sortBy="status"
      >
        Price
      </th>
      <th
        class="table_heading1"
        scope="col"
        [mdbTableSort]="products"
        sortBy="status"
      >
        Avail
      </th>
      <th class="th-buttonrow no-gutters" scope="col">
        <div style="color: transparent;" class="mobile">a</div>
        <div
          class="add-bundle-container no_mobile"
          (click)="addBundle()"
          [routerLink]="toPassForm"
        >
          <div class="add-bundle">&nbsp;&nbsp;&nbsp;Add Bundle</div>
        </div>
        <div
          class="add-pass-container no_mobile"
          (click)="openAddPass()"
          [routerLink]="toPassForm"
        >
          <div class="add-pass">&nbsp;&nbsp;&nbsp;Add Pass</div>
        </div>
      </th>
    </tr>
  </thead>
  <tbody class="body1">
    <ng-container *ngFor="let pass of filter(products); let i = index">
      <tr *ngIf="show(i)" [ngClass]="{ hidden: isHidden(pass) }">
        <td class="pass_name">
          {{ pass.name }}
        </td>
        <td class="no_mobile">
          {{ pass.productTypeMask }}
        </td>
        <td class="no_mobile">
          {{ pass.scheduleTypeMask }}
        </td>
        <td class="no_mobile">
          {{ pass.isPrivate() ? "Private" : "Public" }}
        </td>
        <td *ngIf="!pass.isCustomDaysPass" class="pass_price">
          <a
            style="color: #429DFF;font-size: 15px;"
            (click)="edit(pass)"
            [routerLink]="toScheduleForm"
            >{{ pass.price | currency }}</a
          >
        </td>
        <td *ngIf="pass.isCustomDaysPass" class="pass_price">
          <a
            style="color: #429DFF;font-size: 15px;"
            (click)="edit(pass)"
            [routerLink]="toScheduleForm"
            >Price Varies</a
          >
        </td>
        <td
          style="color: #429DFF;font-size: 15px;"
          (click)="edit(pass)"
          [routerLink]="toScheduleForm"
          class="pass_avail"
        >
          {{
            pass.getAvailablePasses() == null
              ? "N/A"
              : pass.getAvailablePasses() == -1
              ? "Unlimited"
              : pass.getAvailablePasses()
          }}
        </td>
        <td>
          <a
            style="color: #429DFF"
            (click)="edit(pass)"
            [routerLink]="toPassForm"
            ><img
              src="../../../assets/icons/edit.svg"
              style="width:15px;height:15px;margin-right: 5px;"
            /><u style="font-size: 15px;">Details</u>
          </a>
          <br />
          <a
            style="color: #429DFF"
            (click)="edit(pass)"
            [routerLink]="toScheduleForm"
            ><img
              src="../../../assets/icons/edit.svg"
              style="width:15px;height:15px;margin-right: 5px;"
            /><u style="font-size: 15px;">Schedule</u>
          </a>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
<div class="d-flex">
  <div class="chip" mdbDropdown>
    <div class="btn-group" mdbDropdownToggle>
      {{ 10 }}
      <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
    </div>
    <div class="dropdown-menu dropdown-primary">
      <a
        class="dropdown-item"
        *ngFor="let item of itemsPerPage"
        (click)="setItemsPerPage(item)"
        >{{ item }}</a
      >
    </div>
  </div>
  <label>per page</label>
  <div class="example-spacer"></div>
  <div id="paginator">
    <label
      >{{ begin + 1 }} -
      {{ end > products.length ? products.length : end }}
      of
      {{ products.length | number }}
    </label>

    <button
      (click)="decrement()"
      class="fas fa-chevron-left grey-text"
    ></button>
    <button
      (click)="increment(products.length)"
      class="fas fa-chevron-right grey-text"
    ></button>
  </div>
</div>
